import * as S from './styled'
import { useForm, SubmitHandler } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
/**
 * Components
*/
import LayoutWithList from '../../../../LayoutModal/WithList';
import ActionButton from '../../../../Button/ActionButton';
import Loading from "../../../../../components/Loading";
/**
 * hooks
*/
import { apiUpdate } from '../../../../../hooks/apiUpdate';
import { useEffect } from 'react';
import useLoading from '../../../../../hooks/useLoading';
/**
 * Interfaces
*/
import { Inputs } from "Interfaces/ICategory";

interface ICreate {
    isOpenModalMaterial: boolean;
    selectedUrlId: number | null;
    setModalClose: () => void;
    updateList: () => void;
}

export default function Update({
    isOpenModalMaterial,
    setModalClose,
    selectedUrlId,
    updateList
}: ICreate) {

    const {
        register,
        handleSubmit: handleFormSubmit,
        setValue,
        formState: { errors },
    } = useForm<Inputs>();

    const { handleSubmit } = apiUpdate(`category-expense/${selectedUrlId}`);
    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {

            const response = await axiosInstance.get(`category-expense/${selectedUrlId}`);
            const addressData = response.data;
            for (const key in addressData) {
                setValue(key as keyof Inputs, addressData[key]);
            }

        } catch (error) {
            console.log("Error: ", error);
        } finally {
            stopLoading();
        }
    };

    useEffect(() => {
        if (isOpenModalMaterial && selectedUrlId !== null) {
            fetchData();
        }
    }, [isOpenModalMaterial, selectedUrlId]);

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            const formattedData = {
                category_expense: data.category_expense.toUpperCase(),
            };

            const response = await handleSubmit(formattedData);
            if (response === 200) {
                alert("Categoria atualizada com sucesso!");
                updateList();
                setModalClose();
            }
        } catch (error: any) {
            alert(error.message || "Ocorreu um erro ao criar a categoria.");
        }
    };

    if (isOpenModalMaterial) {
        return (
            <LayoutWithList
                title='Editar Categoria'
                subTitle='Atualize as informações do tipo em sua base de dados.'
                setModalClose={setModalClose}
            >
                <S.Container>
                    {
                        isLoading ? (
                            <Loading />
                        ) :
                            <S.SeparateDiv>
                                <S.FormInput>
                                    <S.Label>
                                        Nome da categoria
                                        <span>*</span>
                                    </S.Label>
                                    <S.Input
                                        placeholder="Informe o nome da categoria"
                                        type="text"
                                        {...register("category_expense", { required: true })}
                                    />
                                    {errors.category_expense && <S.InforErro>Campo Obrigatório</S.InforErro>}
                                </S.FormInput>

                                <S.ContentButton>
                                    <ActionButton name='Atualizar' onClick={handleFormSubmit(onSubmit)} />
                                </S.ContentButton>
                            </S.SeparateDiv>
                    }
                </S.Container>
            </LayoutWithList>
        )
    } return null
}